module.exports = __webpack_public_path__ + "images/szvk_small48fb9bc6e356f2829645d9b0485675c9.png";